<template>
  <h1 class="logo">
    <div
      @click="toIndex()"
      @mouseenter="cursorToScroll()"
      @mouseleave="cursorToClose()"
      class="logo__container"
    >
      <img class="logo__image" src="/img/svg/taschen_logo.svg" alt="Taschen Logo">
      <span class="logo__separator"></span>
      <img class="logo__image" src="/img/svg/fwa_logo.svg" alt="FWA Logo">
      <strong class="logo__content">Taschen | FWA</strong>
    </div>

    <a
      href="http://bit.ly/WEBhistory"
      target="_blank"
      rel="noopener"
      class="logo__buy u-hidden--from-ipadL"
      aria-label="buy now"
    >
      Buy Now
    </a>
  </h1>
</template>

<script>
export default {
  name: 'Logo',

  methods: {
    toIndex() {
      if (!this.$store.state.isInTransition) this.$eventHub.$emit('toIndex');
    },

    cursorToScroll() {
      this.$eventHub.$emit('soundInteraction');
      this.$eventHub.$emit('cursorToZoom');
    },

    cursorToClose() {
      if (!this.$store.state.scrollIsLocked) {
        this.$eventHub.$emit('cursorToClose');
      } else {
        this.$eventHub.$emit('cursorToScroll');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.logo {
  width: 100%;
  display: inline-flex;
  align-items: flex-start;
  justify-content: space-between;

  @include mq(ipadL) {
    align-items: center;
    justify-content: flex-end;
  }

  &__container {
    position: relative;

    display: flex;
    align-items: center;
    justify-content: center;

    padding: 10px;

    cursor: pointer;

    @include mq(ipadL) {
      padding: 20px;
    }
  }

  &__image {
    display: inline-block;
    position: relative;
    height: 17px;
    margin: 0;

    @include mq(ipadL) {
      height: 20px;
    }
  }

  &__separator {
    display: inline-block;
    margin: 0 15px 0 18px;
    height: 26px;
    width: 1px;

    background-color: $color-black;
  }

  a {
    position: relative;
    font-size: font-size(s);
    padding: 10px;

    &::before {
      content: '';
      position: absolute;
      bottom: 7px;
      left: 10px;
      height: 1px;
      width: calc(100% - 20px);

      background-color: $color-secondary;
    }
  }

  &__content {
    @include visually-hidden;
  }

  &__buy {
    @include mq($from: ipadL, $and: $is-ipadpro) {
      display: none !important;
    }
  }
}
</style>
